import { createSelector } from '@ngrx/store';
import { selectFeature } from '../../store/admin.selectors';

const selectIntegrationDashboardFeature = createSelector(selectFeature, (state) => state.integrationDashboardState);

export const selectIntegrationEventLogList = createSelector(
    selectIntegrationDashboardFeature,
    (state) => state.integrationEventLogList
);

export const selectIntegrationDashboardIsLoading = createSelector(
    selectIntegrationDashboardFeature,
    (state) => state.isLoading
);

export const selectIntegrationDashboardArgs = createSelector(selectIntegrationDashboardFeature, (state) => state.args);

export const IntegrationDashboardSelectors = {
    selectIntegrationEventLogList,
    selectIntegrationDashboardIsLoading,
    selectIntegrationDashboardArgs
};
